module.exports = __webpack_public_path__ + "static/media/Ford-Mustang-2004.5f3c49fc.webp";